<template>
  <div
    class="absolute bottom-5 left-5 z-10 flex h-[40px]"
    :style="showSlider ? 'width: calc(100vw - 136px)' : ''"
  >
    <ButtonEl
      icon="history"
      :variant="showSlider ? 'primary' : 'tertiary'"
      :class="[
        {
          'rounded-r-none': showSlider,
        },
        'standard-elevation-1',
      ]"
      @click="toggleTimeMachineItems"
    />
    <div
      class="standard-elevation-1 flex rounded-r-[6px]"
      :class="
        showSlider
          ? 'extended-controls visible'
          : 'extended-controls-no-transition'
      "
    >
      <YearSlider class="rounded-l-none" :years="years" />
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import YearSlider from '@/features/year-slider/YearSlider.vue';
import ButtonEl from '@/components/storybook/src/stories/button/ButtonEl.vue';

const store = useStore();

const showSlider = computed(() => store.state.map.showSlider);

const props = defineProps({
  years: Array,
});

function toggleTimeMachineItems() {
  store.commit('map/SET_SLIDER', !showSlider.value);
}
</script>

<style scoped lang="scss">
.extended-controls {
  overflow: hidden;
  max-width: 0;
  transition: max-width 0.25s ease;
}

.extended-controls-no-transition {
  overflow: hidden;
  max-width: 0;
}

.visible {
  @apply w-full;
  max-width: calc(100vw - 175px);
}
</style>
